<div class="mb-4">
  <h2 class="font-weight-extrabold text-center">
    {{ dynamicForm.title }}
  </h2>

  <div [innerHTML]="dynamicForm.description"></div>
</div>

@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="dynamic-form">
      @for (formPanel of dynamicForm.formPanels; track formPanel) {
        <div class="row question-panel"
             [class.subform-panel]="formPanel._subFormPanelMarker">
            @for (item of formPanel.items; track item) {
            <div class="col-lg-12"
                 [ngClass]="{
                'subform-item': item._isSubFormItem,
                'subform-item-start': item._isFirstSubFormItem,
                'subform-item-end': item._isLastSubFormItem,
                'subform-section-title':
                  item._isSubFormItem && item.controlType === 'title' && !item._isFirstSubFormItem,
              }">
                <!-- Title -->
                @if (item.controlType === 'title') {
                <div>
                    <span class="title text-primary text-uppercase font-weight-extrabold">
                        {{ item.label }}
                    </span>
                    @if (item.hoverText) {
                    <div class="ml-2 hover-dropdown" ngbDropdown placement="bottom-right">
                        <div class="pitchin-icon pitchin-icon-info-icon-grey no-caret"
                             ngbDropdownToggle></div>
                        <div class="font-size-smaller hover-text-panel p-3" ngbDropdownMenu>
                            {{ item.hoverText }}
                        </div>
                    </div>
                    }
                </div>
                }
                <!-- Description -->
                @if (item.controlType === 'description') {
                <div class="input-label mt-4" [innerHTML]="item.label"></div>
                }
                @if (item.controlType === 'description' && item.value) {
                <div class="input-desc" [innerHTML]="item.value"></div>
                }
                <!-- Input field -->
                @if (item.controlType !== 'title' && item.controlType !== 'description') {
                <div class="row" [ngClass]="item._isSubFormItem ? 'subform-question-row' : 'mt-4'">
                    <div class="col-sm-12" [ngClass]="item._isSubFormItem ? 'dynamic-form-item-field' : ''">
                        <app-dynamic-form-question [inputClass]="item.class"
                                                   [question]="item"
                                                   [form]="form"
                                                   (subFormTriggered)="onSubFormTriggered($event)">
                        </app-dynamic-form-question>
                    </div>
                </div>
                }
            </div>
            }
        </div>
      }
    </div>
    @if (submitText) {
      <div class="row print-exclude">
        <div class="col-lg-12 text-center">
          <button class="btn btn-primary font-size-larger" type="submit" [disabled]="disableSubmit">
            {{ submitText }}
          </button>
        </div>
      </div>
    }
  </form>
}
